export const H_AND_S_HOLD_REASONS = [
    { code: 'specimen_contamination', label: 'Specimen contamination suspected', requiresNote: true },
    { code: 'identity_mismatch', label: 'Specimen / patient identity mismatch', requiresNote: true },
    { code: 'integrity_compromised', label: 'Specimen integrity compromised' },
    { code: 'safety_review', label: 'Pending biosafety / infection-control review' },
    { code: 'regulatory_hold', label: 'Pending regulatory or accreditation review' },
    { code: 'other', label: 'Other (see note)', requiresNote: true },
];
//# sourceMappingURL=hold-reasons.js.map